import React, { useState } from 'react';
import ExportModal from './ReportExportModal';

const reports = [
    { name: 'Utilization - Broker report', filters: { broker: "Broker", startDate: "Start Date", endDate: "End Date" },
        type: "utilization_report", manualWorkRequired: false },
    { name: 'Broker List', filters: {}, type: "broker_list_report", manualWorkRequired: false },
    { name: 'Vendor List', filters: {}, type: "vendor_list_report", manualWorkRequired: false },
    { name: 'Broker Flags', filters: { broker: "Broker" }, type: "broker_flags_report", manualWorkRequired: false },
    { name: 'Vendor Added Products', filters: {startDate: "Start Date", endDate: "End Date"}, type: "vendor_added_products_report", manualWorkRequired: false },
    { name: 'Vendor Key Contacts', filters: {}, type: "vendor_key_contacts_report", manualWorkRequired: false },
    { name: 'Intent Data', filters: {startDate: "Start Date", endDate: "End Date"}, type: "intent_data_report", manualWorkRequired: false },
    { name: 'Included vendor contacts in project - Lockton Health Plan',
        filters: {}, type: "included_vendor_contacts_report", manualWorkRequired: false },
    { name: 'Search Volume', filters: {}, type: "search_volume_report", manualWorkRequired: false },
    { name: 'Quartal Project Summary', filters: {startDate: "Start Date", endDate: "End Date"},
        type: "quartal_project_summary_report", manualWorkRequired: true },
    { name: 'PPC Report', filters: {}, type: "ppc_report", manualWorkRequired: true },
    { name: 'Reviews/Rating', filters: { broker: "Broker" }, type: "reviews_rating_report", manualWorkRequired: false },
];

const ReportsList = () => {
    const [selectedReport, setSelectedReport] = useState(null);

    return (
        <div className="sl-container sl-m-auto sl-my-8">
            <h1 className="sl-mb-10 sl-text-xl sl-text-gray-900">Reports</h1>

            <div className="sl-row sl-gap-4">
                {reports.map((report, index) => (
                    <div className="sl-col-span-3" key={index}>
                        <div className="sl-font sl-p-8 sl-text-left sl-border sl-border-radius-8 sl-h-56 sl-flex sl-flex-col sl-justify-space-between">
                            <div>
                                <h4 className="sl-mb-2 sl-font-semibold sl-text-gray-900">{report.name}</h4>
                                {(Object.keys(report.filters || {}).length > 0) ? (
                                    <p className={"sl-mt-2 sl-text-sm sl-text-gray-600 "}>
                                        Requires:
                                        {" "}
                                        {Object.entries(report.filters).map(([key, label], idx, arr) => (
                                            <span key={key} className="sl-font-medium sl-text-gray-700">
                                                {label || key}
                                                {idx < arr.length - 1 ? ', ' : '.'}
                                            </span>
                                        ))}
                                    </p>
                                ) : (
                                    <p  className={"sl-mt-2 sl-text-sm sl-text-gray-600 "}>Requires:
                                        <span className="sl-font-medium sl-text-gray-700"> None</span>
                                    </p>
                                )}
                                <p  className={"sl-mt-2 sl-text-sm sl-text-gray-600 "}>
                                    Manual work: {report.manualWorkRequired ? "Yes" : "No"}
                                </p>
                            </div>
                            <button
                                className="sl-btn sl-btn-primary sl-width-100 sl-p-2"
                                onClick={() => setSelectedReport(report)}
                            >
                                Export
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {selectedReport && (
                <ExportModal
                    report={selectedReport}
                    onClose={() => setSelectedReport(null)}
                    onExport={() => setSelectedReport(null)}
                />
            )}
        </div>
    );
};

export default ReportsList;
